import { useEffect } from 'react';

const SITE = 'https://rakshan-shetty.netlify.app';

const setMeta = (selector, attr, key, value) => {
  let el = document.head.querySelector(selector);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  const previous = el.getAttribute('content');
  el.setAttribute('content', value);
  return () => (previous === null ? el.remove() : el.setAttribute('content', previous));
};

/**
 * Per-route title, description, canonical and social tags for client-rendered pages.
 * Restores the home page values on unmount so navigating back stays correct.
 */
export function usePageMeta({ title, description, path }) {
  useEffect(() => {
    if (!title) return undefined;
    const prevTitle = document.title;
    document.title = title;
    const url = `${SITE}${path || ''}`;
    const undo = [
      description && setMeta('meta[name="description"]', 'name', 'description', description),
      setMeta('meta[property="og:title"]', 'property', 'og:title', title),
      description && setMeta('meta[property="og:description"]', 'property', 'og:description', description),
      setMeta('meta[property="og:url"]', 'property', 'og:url', url),
      setMeta('meta[name="twitter:title"]', 'name', 'twitter:title', title),
      description && setMeta('meta[name="twitter:description"]', 'name', 'twitter:description', description),
    ].filter(Boolean);
    const canonical = document.head.querySelector('link[rel="canonical"]');
    const prevCanonical = canonical?.getAttribute('href');
    canonical?.setAttribute('href', url);
    return () => {
      document.title = prevTitle;
      undo.forEach((fn) => fn());
      if (canonical && prevCanonical) canonical.setAttribute('href', prevCanonical);
    };
  }, [title, description, path]);
}
